import { onUnmounted, getCurrentInstance } from '@vue/composition-api'
import StoreBase from './StoreBase'
import store from '@/store'
import tools from '@/sag-core/tools'
import utils from '../utils'
export default class PageBase {

    constructor(
        pageInfo = {
            serviceName: 'default', 
            pageStore: new StoreBase('default')
        }
    )
    {
        tools.debug.log({tag: 'test', title: 'PageBase檢查', content: 'PageBase物件傳入的pageInfo'}, pageInfo)
        this.route = getCurrentInstance().proxy.$route

        if(utils.isSingle(this.route)){
            this.serviceName = 's-' + pageInfo.serviceName
            pageInfo.serviceName = 's-' + pageInfo.serviceName
            store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', true)
            store.commit('appConfig/UPDATE_NAVBAR_CONFIG', {type: 'hidden'})
        }
        else{
            this.serviceName = pageInfo.serviceName
        }
    
        if (!store.hasModule(pageInfo.serviceName)) {
            store.registerModule(pageInfo.serviceName, pageInfo.pageStore(pageInfo.serviceName))
        }
    
        onUnmounted(() => {
            if (store.hasModule(pageInfo.serviceName)) store.unregisterModule(pageInfo.serviceName)
        })
    }

    
}

